import { createSlice } from '@reduxjs/toolkit';
import { type SnackbarProps } from '@mui/material';

export type MessageVariant = 'success' | 'warning' | 'error' | 'info' | null;

interface MessageState {
	state: boolean;
	options: Omit<SnackbarProps, 'open'> & { variant: MessageVariant };
}

const initialState: MessageState = {
	state: false,
	options: {
		anchorOrigin: {
			vertical: 'top',
			horizontal: 'center'
		},
		autoHideDuration: 6000,
		message: 'Hi',
		variant: null
	}
};

const messageSlice = createSlice({
	name: 'message',
	initialState,
	reducers: {
		showMessage: (state, action) => {
			state.state = true;
			state.options = {
				...initialState.options,
				...action.payload
			};
		},
		hideMessage: state => {
			state.state = false;
		}
	}
});

export const { hideMessage, showMessage } = messageSlice.actions;

export default messageSlice.reducer;
